import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paychex',
  templateUrl: './paychex.component.html',
  styleUrls: ['./paychex.component.scss']
})
export class PaychexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
